import React from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

const ServerErrorPage: React.FC = () => {
  const navigate = useNavigate();
  const { isAuthenticated } = useAuth();
  const [searchParams] = useSearchParams();

  const errorMessage =
    searchParams.get("message") ||
    "サーバーで問題が発生しました。しばらく時間をおいてから再度お試しください。";

  const handleGoHome = () => {
    if (isAuthenticated) {
      navigate("/dashboard");
    } else {
      navigate("/login");
    }
  };

  const handleReload = () => {
    window.location.reload();
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-red-500 to-orange-600 flex items-center justify-center p-5">
      <div className="bg-white rounded-xl shadow-2xl p-10 w-full max-w-[500px] text-center">
        <div className="mb-8">
          <div className="text-8xl font-bold text-transparent bg-clip-text bg-gradient-to-br from-red-500 to-orange-600 mb-4">
            500
          </div>
          <h1 className="text-3xl font-bold text-gray-800 mb-4">
            サーバーエラー
          </h1>
          <p className="text-gray-600 leading-relaxed mb-4">{errorMessage}</p>

          <div className="bg-red-50 border border-red-200 rounded-lg p-4 text-left">
            <p className="text-sm text-red-800 mb-2">
              <strong>エラーが続く場合:</strong>
            </p>
            <ul className="text-sm text-red-700 list-disc list-inside space-y-1">
              <li>ブラウザのキャッシュをクリアしてください</li>
              <li>別のブラウザで試してください</li>
              <li>しばらく時間をおいてから再度アクセスしてください</li>
            </ul>
          </div>
        </div>

        <div className="space-y-3">
          <button
            onClick={handleReload}
            className="w-full py-3 px-6 bg-red-600 text-white border-none rounded-md text-base font-medium cursor-pointer transition-colors hover:bg-red-700"
          >
            ページを再読み込み
          </button>
          <button
            onClick={handleGoHome}
            className="w-full py-3 px-6 bg-white text-gray-700 border-2 border-gray-300 rounded-md text-base font-medium cursor-pointer transition-colors hover:bg-gray-50"
          >
            {isAuthenticated ? "ダッシュボードに戻る" : "ログインページへ"}
          </button>
        </div>

        <div className="mt-8 pt-6 border-t border-gray-200">
          <p className="text-sm text-gray-500">
            問題が解決しない場合は、お手数ですがお問い合わせください。
          </p>
        </div>
      </div>
    </div>
  );
};

export default ServerErrorPage;
